import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { usePresence } from 'framer-motion';
import { useHasMounted } from "./..";
import { useEffect } from 'react';
import { easeCurves } from "../../motion/eases";
export function usePresenceAnimation(_ref) {
  var _ref$exitDuration = _ref.exitDuration,
      exitDuration = _ref$exitDuration === void 0 ? 150 : _ref$exitDuration,
      styles = _ref.styles;

  var _usePresence = usePresence(),
      _usePresence2 = _slicedToArray(_usePresence, 2),
      isPresent = _usePresence2[0],
      safeToRemove = _usePresence2[1];

  var hasMounted = useHasMounted();
  useEffect(function () {
    if (!isPresent) {
      window.setTimeout(safeToRemove, exitDuration);
    }
  }, [exitDuration, isPresent, safeToRemove]);

  if (!hasMounted && isPresent) {
    return styles.initial;
  }

  if (hasMounted && isPresent) {
    return _objectSpread({
      transition: "all 200ms ".concat(easeCurves.primary)
    }, styles.animate);
  }

  return _objectSpread({
    transition: "all ".concat(exitDuration, "ms ").concat(easeCurves.primary)
  }, styles.exit);
}